import { sum2Objects } from "../../Utils";
const params = [ 'spends', 'conversions'];

export function prepareDaysCountryReport(reportRaw) {
    const days = [];
    const keysObj = {};
    let currIndex = 0;

    const report = reportRaw
        .reduce((arr, { affid, device, day, ...obj }) => {
            params.forEach(param => {
                const paramData = obj[param];
                if(paramData) {
                    Object.keys(paramData).forEach(country => {
                        const key = `${affid}:${country}:${device}`;
                        const index = keysObj[key];

                        const value = paramData[country];

                        if(index === undefined) {
                            arr.push({ affid, country, device, daysData: { [day]: { [param]: value } } });
                            keysObj[key] = currIndex++;
                        }
                        else {
                            if(arr[index].daysData[day]) {
                                if(arr[index].daysData[day][param]) arr[index].daysData[day][param] += value;
                                else arr[index].daysData[day][param] = value;
                            }
                            else arr[index].daysData[day] = { [param]: value };
                        }
                    });
                }
            }, []);

            if(days.indexOf(day) === -1) days.push(day);

            return arr;
        }, [])
        .map(obj => {
            Object.keys(obj.daysData).forEach(day => {
                const dayData = obj.daysData[day];

                obj.daysData[day].eCost = calculateECost(dayData.spends, dayData.conversions);
            });


            return obj;
        });

    return { report, days };
}

export function prepareDaysReport(reportRaw) {
    const days = [];
    const keysObj = {};
    let currIndex = 0;

    const report = reportRaw.reduce((arr, { affid, subid, device, day, ...obj }) => {
        obj.eCost = getECost(obj.spends, obj.conversions);
        obj.avgECost = calculateECost(obj.totalSpends, obj.totalConversions);

        const key = `${affid}:${subid}:${device}`;
        const index = keysObj[key];

        if(index === undefined) {
            arr.push({ affid, subid, device, daysData: { [day]: obj} });
            keysObj[key] = currIndex++;
        }
        else arr[index].daysData[day] = obj;

        if(days.indexOf(day) === -1) days.push(day);

        return arr;
    }, []);

    return { report, days };
}

export function preparePeriodReport(reportRaw) {
    const keysObj = {};
    let currIndex = 0;

    const report = reportRaw
        .reduce((arr, obj) => {
            delete obj.day;

            const key = `${obj.affid}:${obj.subid}:${obj.device}`;
            const index = keysObj[key];

            if(index === undefined) {
                arr.push(obj);
                keysObj[key] = currIndex++;
            }
            else {
                arr[index].spends = sum2Objects(arr[index].spends, obj.spends);
                arr[index].conversions = sum2Objects(arr[index].conversions, obj.conversions);
                arr[index].totalSpends = arr[index].totalSpends + obj.totalSpends;
                arr[index].totalConversions = arr[index].totalConversions + obj.totalConversions;
            }

            return arr;
        }, [])
        .map(obj => {
            obj.eCost = getECost(obj.spends, obj.conversions);
            obj.avgECost = calculateECost(obj.totalSpends, obj.totalConversions);

            return obj;
        });

    return { report};
}

export function preparePeriodCountryReport(reportRaw) {
    const keysObj = {};
    let currIndex = 0;

    const report = reportRaw
        .reduce((arr, { affid, device, day, ...obj }) => {
            params.forEach(param => {
                const paramData = obj[param];
                if(paramData) {
                    Object.keys(paramData).forEach(country => {
                        const key = `${affid}:${country}:${device}`;
                        const index = keysObj[key];

                        const value = paramData[country];

                        if(index === undefined) {
                            arr.push({ affid, country, device, [param]: value });
                            keysObj[key] = currIndex++;
                        }
                        else {
                            if(arr[index][param]) arr[index][param] += value;
                            else arr[index][param] = value;
                        }
                    });
                }
            });

            return arr;
        }, [])
        .map(obj => {
            obj.eCost = calculateECost(obj.spends, obj.conversions);

            return obj;
        });

    return { report };
}

export function calculateECost(spends, conversions) {
    return spends && conversions ? spends / conversions : 0;
}

function getECost(spends, conversions) {
    if(!spends || !conversions) return {};

    return Object.keys(spends).reduce((obj, country) => {
        const countrySpends = spends[country];
        const countryConversions = conversions[country];

        obj[country] = calculateECost(countrySpends, countryConversions);

        return obj;
    }, {});
}


// WEBPACK FOOTER //
// ./src/scenes/BidderECost/prepareReport.js